export default __webpack_public_path__ + "static/media/pinContained.8ab37add.svg";